import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * Değerlerimiz — kendi sayfası.
 *
 * 31.08.2026'da istendi: Hakkımızda sayfasında yalnızca görsel, tek bir cümle ve
 * "Değerlerimiz" butonu kalsın; buton da görsel de değerlerin kendisine gitsin.
 * Sekiz değer bu yüzden buraya taşındı — özetlenmeden, olduğu gibi.
 *
 * Aynı gün, digitopia.co'nun kendi sayfasının üç ekran görüntüsüyle "birebir
 * aynısı olsun" denildi: ortalanmış sade bir başlık, ardından her değer için tam
 * genişlikte gri bir kart — solda mavi başlık, sağda her cümle kendi satırında.
 * Alttaki "Contact Us" bandı hariç tutuldu, o tasarım bizim.
 */
export const ourValues: WrittenPage = {
  navLabel: 'Değerlerimiz',
  title: 'Değerlerimiz',
  description:
    'Digitopian\'ların birbirini sorumlu tuttuğu sekiz değer: mütevazı ama cesur, inisiyatifli sahiplik, evet yaparız, mevcut durumu sorgula, paylaş önünü aç, keyfini çıkar, öğrenmeye aç, bir amaç için çalış.',
  sections: [
    {
      kind: 'hero',
      headline: 'Değerlerimiz',
      align: 'center',
    },
    {
      kind: 'features',
      variant: 'rows',
      items: [
        {
          title: 'Mütevazı ama cesur.',
          lines: [
            'Mütevazıyız ama yanılmayın…',
            'Büyük hayal kurarız.',
            'Kendimize güveniriz.',
            'Ve cesuruz.',
          ],
        },
        {
          title: 'İnisiyatifli sahiplik',
          lines: [
            'Her bir çalışma arkadaşımızın değer üretmekten sorumlu olduğuna inanırız.',
            'Yaptığımız her şeyin hesabını veririz ve sorumluluklarımızı taşırken inisiyatif almayı isteriz.',
            'İşin elimizden kaçmasına izin vermeyiz; sıkı tutarız ve başarana kadar deneriz.',
          ],
        },
        {
          title: 'Evet, yaparız!',
          lines: [
            'Hedeflerimize ulaşmanın yolunu her zaman buluruz.',
            'Bir zorlukla karşılaştığımızda çözeriz.',
            'Bir engele çarptığımızda aşarız.',
            'Bilmediğimiz bir şey olduğunda da öğreniriz.',
          ],
        },
        {
          title: 'Mevcut durumu sorgula.',
          lines: [
            'Bize status quo olarak sunulanı kabul etmeyiz.',
            'Değiştirmek için buradayız.',
            'Özenle deneriz.',
            'Dünyamızı daha iyi kılmak için cesaret ederiz.',
            'Hayatta, insanlarda, işin teslimatında yaratıcılık ararız.',
          ],
        },
        {
          title: 'Paylaş, önünü aç',
          lines: [
            'Birlikte üretilen bilgi elde edebileceğimiz en büyük deneyimdir.',
            'Birey olarak her birimizin kendi bilgisi ve deneyimi var.',
            'Paylaştığımızda başkalarının önünü açtığımıza inanırız.',
            'Karşılığında onlar bizim önümüzü açar.',
            'Hepimiz birbirimizin önünü açtıkça ve paylaşarak deneyim kazandıkça bu sürecin getirisi çok büyük olur.',
          ],
        },
        {
          title: 'Keyfini çıkar!',
          lines: [
            'Bunun açıklamaya gerçekten ihtiyacı var mı? 😊',
            'Zamanımızın çoğunu işte geçiriyoruz.',
            'Neden keyfini çıkarmayalım?',
            'Eksik bir şey mi var? Canınızı sıkan bir şey mi var? Çözün.',
            'Ve keyif devam etsin!',
          ],
        },
        {
          title: 'Öğrenmeye aç',
          lines: [
            'Bilgiye her zaman açız.',
            'Okuruz, büyürüz; yaptığımız her şeyi anlar, içselleştirir, uygular, hayata geçirir ve geliştiririz.',
            'Öğrenmeyi hiç bırakmayız.',
          ],
        },
        {
          title: 'Bir amaç için çalış',
          lines: [
            'Sadece çalışmıyoruz; bir amaç için çalışıyoruz.',
            'İşimizde sürekli anlam ararız.',
            'Bunu yalnızca para için yapmayız.',
            'İnsanlara ve içinde yaşadığımız dünyaya hizmet etmek için buradayız.',
          ],
        },
      ],
    },
    {
      kind: 'cta',
      heading: 'Bir Digitopian olun.',
      sub: 'Cesaret, sahiplik ve merak arıyoruz. Gerisi öğrenilebilir ve öğrenmenize yardım ederiz.',
      tone: 'band',
      headingHref: LINKS.careers,
      ctas: [{ label: 'Açık pozisyonlara bakın', href: LINKS.careers }],
    },
  ],
}
